<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Redeemed Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Reports</b> /
      <b>Graph</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <button class="btn btn-primary" @click="print">Print</button>
      </div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group col-lg-6 col-sm-12 pl-0 pl-sm-3" role="group">
          <button
            class="btn btn-secondary active"
            id="btn-month"
            type="button"
            @click="month()"
          >
            Monthly
          </button>
          <button
            class="btn btn-secondary"
            id="btn-product"
            type="button"
            @click="product()"
          >
            Products
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-12 col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-12 col-lg-6 col-sm-12"></div>

              <div
                class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
              >
                <span class="m-auto"></span>
                <!-- Year -->
                <div class="col-6">
                  <div class="form-group">
                    <label>Year</label>
                    <select class="form-control" v-model="filter_year">
                      <option v-for="(year, index) in years" :key="index">{{
                        year
                      }}</option>
                    </select>
                  </div>

                  <div class="form-group" v-if="clickProduct">
                    <label>Month</label>
                    <select class="form-control" v-model="filter_month">
                      <option
                        v-for="(month, index) in months"
                        :key="index"
                        :value="index"
                        >{{ month }}</option
                      >
                    </select>
                  </div>

                  <div class="form-group">
                    <button class="btn btn-primary" @click="applyFilter()">
                      Filter
                    </button>
                    &nbsp;
                    <button
                      id="btnAll"
                      class="btn btn-primary d-none"
                      @click="removeFilter()"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />

          <div id="printGraph">
            <div id="monthly" v-if="clickMonth">
              <h4 class="text-center">
                <b>Vouchers Used For Year {{ year }}</b>
              </h4>

              <GChart
                type="ColumnChart"
                :data="voucherMonthlyData"
                :options="voucherMonthlyOptions"
              />
            </div>

            <div id="product" v-if="clickProduct">
              <h4 class="text-center">
                <b>Vouchers Used For {{ month_name }} {{ year }}</b>
              </h4>
              <GChart
                type="ColumnChart"
                :data="voucherData"
                :options="voucherOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart
  },

  data() {
    return {
      voucherMonthlyData: [],
      voucherData: [],

      voucherMonthlyOptions: {
        height: 600,
        legend: "bottom",
        vAxis: { title: "Total Price Redeemed ($)" },
        hAxis: { title: "Month" }
      },

      voucherOptions: {
        height: 600,
        legend: "bottom",
        vAxis: { title: "No. Products Redeemed" },
        hAxis: { title: "Product Names" }
      },

      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],

      month_name: "",
      year_name: "",

      year: 0,
      years: [],

      filter_month: "",
      filter_year: "",

      clickMonth: true,
      clickProduct: false
    };
  },

  methods: {
    //print graph
    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    getMonthlyVouchers() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/point/voucher/month/demographic", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.voucherMonthlyData = res.data.Bar_Chart;
          });
      }
    },

    getProduct() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/point/voucher/product/demographic", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.voucherData = res.data.Bar_Chart;
            this.month_name = res.data.selected_month;
          });
      }
    },

    loadData() {
      this.getMonthlyVouchers();
      this.getProduct();
    },

    month() {
      this.clickMonth = true;
      this.clickProduct = false;

      $("#btn-month").addClass("active");
      $("#btn-product").removeClass("active");
    },

    product() {
      this.clickProduct = true;
      this.clickMonth = false;

      $("#btn-product").addClass("active");
      $("#btn-month").removeClass("active");
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      this.year = current_year;

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");

      // Declare filters
      let year = "";
      let month_name = "";

      if (this.filter_year.length != 0) {
        year = "?filter_year=" + this.filter_year;
        this.year = this.filter_year;
      }

      if (this.filter_month.length != 0 && this.filter_year.length != 0) {
        month_name = "&filter_month=" + (this.filter_month + 1);
      } else {
        month_name = "?filter_month=" + (this.filter_month + 1);
      }

      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/point/voucher/month/demographic" + year, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.voucherMonthlyData = res.data.Bar_Chart;
          });

        axios
          .get(
            axios.lpsURL +
              "/point/voucher/product/demographic" +
              year +
              month_name,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.voucherData = res.data.Bar_Chart;
            this.month_name = res.data.selected_month;
          });
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_year = "";
      this.filter_month = "";
      this.years = [];

      this.loadYearFilter();

      this.loadData();
    }
  },

  mounted() {
    let user = JSON.parse(localStorage.getItem("user"));

    if (user.username !== "vendor.takaful") {
      swal({
        icon: "error",
        text: "You are unauthorized user"
      }).then(() => {
        this.$router.push("/banner");
      });
    }

    this.loadData();
    this.loadYearFilter();
  }
};
</script>
